import { VIEW_TYPE } from 'Pods/ThreeDStudio/Store/constants'

// Translation keys under shared.actionSelector.imageUploader.multiView.views, per view.
export const VIEW_LABEL_KEYS = {
  [VIEW_TYPE.FRONT]: 'front',
  [VIEW_TYPE.LEFT]: 'left',
  [VIEW_TYPE.RIGHT]: 'right',
  [VIEW_TYPE.BACK]: 'back',
  [VIEW_TYPE.TOP]: 'top',
  [VIEW_TYPE.BOTTOM]: 'bottom',
  [VIEW_TYPE.LEFT_FRONT]: 'leftFront',
  [VIEW_TYPE.RIGHT_FRONT]: 'rightFront',
}

export const viewLabelKey = viewType => (
  `shared.actionSelector.imageUploader.multiView.views.${VIEW_LABEL_KEYS[viewType]}`
)
